const isDefined = v => v !== undefined && v !== null;

export default isDefined;
